export function SparkIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 2.5c.5 5 2.6 7.2 7.5 7.8-4.9.6-7 2.8-7.5 7.8-.5-5-2.6-7.2-7.5-7.8C9.4 9.7 11.5 7.5 12 2.5Z" />
      <path d="M19 15.4c.2 2.2 1.2 3.2 3.3 3.5-2.1.3-3.1 1.3-3.3 3.5-.2-2.2-1.2-3.2-3.3-3.5 2.1-.3 3.1-1.3 3.3-3.5Z" />
    </svg>
  );
}

export function CloseIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="m6 6 12 12M18 6 6 18" />
    </svg>
  );
}

export function SendIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="m4 12 15-7-5.8 14-2.1-5.8L4 12Z" />
      <path d="m11.1 13.2 3.8-3.8" />
    </svg>
  );
}

export function CheckIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="m5 12.5 4.2 4.2L19 7" />
    </svg>
  );
}
